import React from 'react';
import { FaPhone, FaMapMarkerAlt } from 'react-icons/fa';


const ContractorCard = ({ contractor }) => {
    const { first_name, last_name, username, city, services, avatar, description } = contractor;
    const fullName = `${first_name || ''} ${last_name || ''}`;

    return (
        <div className="contractor-card mb-4 rtl">

            <div className="card-header-section rtl">
                <div className="info">
                    <h5 className="fw-bold">{fullName}</h5>
                    <div className="d-flex flex-column align-items-start gap-2">
                        <div className="info-pill phone-pill">
                            <FaPhone />
                            <span>{username}</span>
                        </div>
                        {city && (
                            <div className="info-pill city-pill">
                                <FaMapMarkerAlt />
                                <span>{city.name}</span>
                            </div>
                        )}
                    </div>
                </div>
                <div className="avatar-wrapper">
                    <img src={avatar} alt={`آواتار ${fullName}`} className="avatar rounded-circle" />
                </div>
            </div>

            {
                description &&

            <div className="services-section">

                <h6 className="fw-bold">توضیحات:</h6>
                <div className="d-flex flex-wrap gap-2">
                    <p className='text-small-1'>
                        {description.substring(0,150)}
                    </p>
                </div>
            </div>
            }
            {/* بخش پایینی کارت: خدمات */}
            <div className="services-section">

                <h6 className="fw-bold">خدمات:</h6>
                <div className="d-flex flex-wrap gap-2">
                    {services && services.length > 0 ? (
                        services.map(service => (
                            <span key={service.id} className="service-tag">
                {service.title}
              </span>
                        ))
                    ) : (
                        <p className="text-muted small mb-0">هیچ خدمتی برای این پیمانکار ثبت نشده است.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContractorCard;
